export const HtmlPage = () => (
  <iframe
    src="/page.html"
    title="HTML page"
    style={{ width: "100%", height: "100vh", border: "none" }}
  />
);
